import { PageTitle, PageTitleContainer } from "@/ui-components/utils/menu-items/page-title";
import { useSearchParams } from "react-router-dom";
import SalesEditor from "../sales-editor";

const CreateSalesItem = () => {
  const [searchParams] = useSearchParams();
  const dealId = searchParams.get("dealId");

  if (!dealId) {
    return <div>Kein Deal gefunden</div>;
  }

  return (
    <div>
      <PageTitleContainer>
        <div className="flex flex-row justify-between items-center">
          <PageTitle>Neue Verkaufsposition erstellen</PageTitle>
        </div>
      </PageTitleContainer>
      <div className="p-4 w-1/2 items-center m-auto">
        <SalesEditor dealId={dealId ?? undefined} />
      </div>
    </div>
  );
};

export default CreateSalesItem;
